import { fbt } from 'fbtee'
import { Inbox, MessageSquare } from 'lucide-react'
import { CountBadge } from '../../components/CountBadge'
import { useGuestGuard } from '../../hooks/useGuestGuard'
import { useRequestsUnread } from '../../hooks/useRequestsUnread'
import { myRequestsPrompt } from '../../lib/guestPrompts'
import { supportsShake } from '../../lib/shakeToReport'
import { useTransitionNavigate } from '../../lib/viewTransition'
import { ShakeToReportSettingsRow } from './ShakeToReportSettingsRow'
import { WhatsNewSettingsRow } from './WhatsNewSettingsRow'
import { SettingsLinkRow, SettingsSection } from './SettingsSection'

export function HelpSection({ signedIn, hasUser }: { signedIn: boolean; hasUser: boolean }) {
  const navigate = useTransitionNavigate()
  const { prompt } = useGuestGuard()
  const requestsUnread = useRequestsUnread(false)

  return (
    <SettingsSection title={fbt('Help', 'Settings section holding support, requests, what is new and bug reporting')}>
      <SettingsLinkRow
        icon={<MessageSquare className="size-4" />}
        label={fbt('Help & Feedback', 'Row in Settings that opens the support page')}
        onClick={() => navigate('/support')}
      />
      <SettingsLinkRow
        icon={<Inbox className="size-4" />}
        label={fbt('My requests', 'Row in Settings linking to the My requests page')}
        badge={<CountBadge count={requestsUnread} data-testid="my-requests-badge" />}
        onClick={() => (signedIn ? navigate('/requests') : prompt(myRequestsPrompt()))}
        testId="my-requests-row"
      />
      <WhatsNewSettingsRow />
      {hasUser && supportsShake() && <ShakeToReportSettingsRow />}
    </SettingsSection>
  )
}
